export default __webpack_public_path__ + "static/media/drag_n_drop_en.bee1ba80.gif";